import { Component } from '@verndale/core';

class HtmlTemplateModals extends Component {
  setupDefaults(): void {
    this.dom = {
      closeBtn: this.el.querySelector<HTMLElement>('.modal-close a'),
      modalContainer: this.el.querySelector<HTMLElement>('.modal-container'),
      modalContentBox: this.el.querySelector<HTMLElement>('.modal-content-box'),
      modalContents: this.el.querySelectorAll('div[id]')
    };

    (this.dom.modalContents as NodeListOf<HTMLElement>).forEach(content => {
      content.hidden = true;
    });
  }

  addListeners(): void {
    document.body.querySelectorAll('a.launch-modal').forEach(trigger => {
      trigger.addEventListener('click', this.handleClickModal.bind(this));
    });

    (this.dom.closeBtn as HTMLElement)?.addEventListener('click', this.handleCloseModal.bind(this));
  }

  handleCloseModal() {
    console.log('close');
    const body = document.querySelector('body') as HTMLElement;
    body.style.removeProperty('overflow');
    (this.dom.modalContentBox as HTMLElement).innerHTML = '';
    (this.el as HTMLDialogElement).close();
  }

  handleClickModal(e: Event) {
    const body = document.querySelector('body') as HTMLElement;
    body.style.overflow = 'hidden';
    const modalTrigger = e.currentTarget as HTMLElement;
    const modalData = modalTrigger.dataset.target;
    if (!modalData) return;
    const modal = this.el.querySelector(modalData);
    if (!modal) return;
    const modalCopy = modal.cloneNode(true) as HTMLElement;
    modalCopy.hidden = false;
    (this.dom.modalContentBox as HTMLElement)?.appendChild(modalCopy);
    (this.el as HTMLDialogElement).showModal();
    e.preventDefault();
  }
}

export default HtmlTemplateModals;
